<div class="multi-select" (mouseleave)="showDropDown && outSelectValue()">
    <input  type="text" id="selPart" class="drop-toggle btn flat" [(ngModel)]="itemSlted" (ngModelChange)="modelChangeFn($event)"
    (click)="showDropDown=!showDropDown" [ngClass]="{'active': showDropDown}">
    <div class="drop-show " [ngClass]="{'scroll-box': items.length >=20}" *ngIf="showDropDown">
        <div *ngFor="let it of items; index as i">
            <label (click)="selected(it)" [ngClass]="{'active': it.active}">
                {{it.ResultValue}}
            </label>
        </div>
    </div>
</div>